import { Pagination } from 'swiper';
// Angular Core
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
// Models
import { Achievement } from 'src/app/models/achievement/achievement';
import { Agent } from 'src/app/models/agent/agent';
import { ICardCommonData } from 'src/app/models/card-common-data/card-common-data';
import { Feature } from 'src/app/models/feature/feature';
import { Property, SaleType } from 'src/app/models/property/property';
import { Testimonial } from 'src/app/models/testimonial/testimonial';
// Mock Data
import { AgentsMock, FeaturesMock } from '../../mock/mock';
import { webPageCity } from '../../web-page-city.data'
// Rxjs
import { Subject, Subscription, zip } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Base Http Provider
import { HomeService } from './services/home.service';
// Responsive service
import { BreakPoints } from 'src/app/core/ui/responsive/responsive-breakpoints';
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';
// Swiper
import { SwiperOptions } from 'swiper/types';
import SwiperCore, { Autoplay } from 'swiper'
import { AppPageService } from 'src/app/core/ui/document-title/app-page.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CountUp } from 'countup.js';
import { PlatformService } from 'src/app/core/platform/platform.service';
import { NgxSpinnerService } from "ngx-spinner";

// install Swiper modules
SwiperCore.use([Autoplay, Pagination]);
@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent extends AppPageService implements OnInit, OnDestroy {
  public isHome: boolean = true;

  @ViewChild('featuredListSection') featuredListSection: ElementRef | undefined;

  // Data Properties
  agents: Agent[] = AgentsMock;
  features: Feature[] = FeaturesMock;
  properties: Property[] = [];
  propertyByCities: { url_name: string, page_title: string }[] = webPageCity;
  achievements: Achievement[] = [];
  testimonials: Testimonial[] = [];
  achievementsData: any = [];
  // Flags
  public featureReadMore = false;
  counterFlag: boolean = true;
  // Swiper Configs
  config2: SwiperOptions = {
    preloadImages: false,
    slidesPerView: 1,
    spaceBetween: 100,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    centeredSlides: true,
    loop: true,
    navigation: false,
    pagination: { clickable: true },
    scrollbar: { draggable: false },
    lazy: true,
  };
  config1: SwiperOptions = {
    // slidesPerView: 3,
    preloadImages: false,
    breakpoints: {
      1920: {
        slidesPerView: 3,
      },
      1600: {
        slidesPerView: 3,
      },
      1400: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      600: {
        slidesPerView: 1,
      },
    },
    spaceBetween: 0,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    loop: true,
    pagination: { clickable: true },
    scrollbar: { draggable: false },
    lazy: true,
  };

  // Subscriptions
  screenBreakPointsSubcription: Subscription | undefined;
  destroy$ = new Subject<boolean>();
  constructor(
    private homeService: HomeService,
    private responsiveService: ResponsiveService,
    protected titleService: Title,
    private metaService: Meta,
    protected activatedRoute: ActivatedRoute,
    private platformService: PlatformService,
    private spinner: NgxSpinnerService,
  ) {
    super(titleService, activatedRoute);
    this.initData();
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  ngOnInit(): void {
    // TODO: Can manually update the page title from here using the Base class's `setTitle` method as shown below
    // By default the title will be set for you making use of the routing configurations
    // this.setTitle('Home');
    this.titleService.setTitle('Michigan Property Management | Rental Property Management Company in Michigan');
    this.metaService.addTags([
      { name: 'keywords', content: `Property Management Company, Rental Property Management, Property Management Services` },
      { name: 'description', content: `Michigan Based North Bloomfield Properties Management Company offers Rental Property Management Services for Property Owners and Tenants in the Michigan area.` }
    ]);
    this.setScreenBreakpointsListener();

  }
  initData() {
    this.spinner.show();
    zip(
      this.homeService.getProperty({ limit: 8 }),
      this.homeService.getTestimonial(),
      this.homeService.getAchievement(),
    ).subscribe(([properties, testimonials, achievements]) => {
      if (properties.data.resultData) {
        this.properties = properties.data.resultData.map((element: any) => {
          let thumbImg = element.PropertyImages[0]
          // console.log(element.address)
          element.PropertyImages.map((ele: any, i: number) => {
            if (ele.isThumb == 1) {
              thumbImg = ele
            }
          })
          const details = {
            id: `${element.id}`,
            createdAt: new Date(`${element.createdAt}`).toISOString(),
            propertyType: (element.mode == 1) ? SaleType.ForSale : (element.mode == 2) ? SaleType.ForRent : (element.mode == 3) ? SaleType.ForRentAndSale : (element.mode == 4) ? SaleType.Deposite : SaleType.Deposite,
            title: element.place,
            price: (element.mode == 1) ? element.amount : (element.mode == 2) ? element.rent : (element.mode == 3) ? element.rent : (element.mode == 4) ? element.deposit : element.deposit,
            address: element.address,
            noOfBeds: element.PropertyBed ? element.PropertyBed.quantity : null,
            residenceType: element.PropertyType ? element.PropertyType.name : '',
            areaInSquareFt: element.area,
            noOfBaths: element.PropertyBath ? element.PropertyBath.quantity : null,
            image: `https://northbloomfield.s3.us-east-2.amazonaws.com/${thumbImg?.smallPath}`,
            // image: 'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
            city: element.City ? element.City.name : '',
            place: element.place,
          }
          return new Property(
            details.id, details.createdAt, details.propertyType, details.title, details.price, details.address, details.noOfBeds, details.residenceType, details.areaInSquareFt, details.noOfBaths, details.image, details.city, details.place
          )
        })
      }
      if (testimonials) {
        this.testimonials = testimonials.data.map((element: any) => {
          return {
            title: element.name,
            content: element.description
          }
        })
      }
      if (achievements) {
        this.achievements = [
          new Achievement(`${achievements.data.sale_count}`, 'Listings For Sale', 'tags'),
          new Achievement(`${achievements.data.rent_count}`, 'Listings For Rent', 'dollar-sign'),
          new Achievement(`${achievements.data.agent}`, 'Our Agents', 'user'),
          new Achievement(`${achievements.data.year_of_excellence}`, 'Years of Excellence', 'medal'),
        ]
        this.achievementsData = this.achievements.map((element) => {
          return {
            title: Number(element.title),
            content: element.content,
            iconString: element.iconString,
          }
        })
      }
    },()=>{this.spinner.hide();},()=>{this.spinner.hide();})
  }
  public achievementTrackByFn(index: number, achievement: Achievement) {
    return achievement.title;
  }
  public featureTrackByFn(index: number, feature: ICardCommonData) {
    return feature.title;
  }
  public testimonyTrackByFn(index: number, testimonial: Testimonial) {
    return testimonial.title;
  }
  public agentTrackByFn(index: number, agent: Agent) {
    return agent.name;
  }
  public readMoreFeatures() {
    this.featureReadMore = !this.featureReadMore;
  }
  /**
 * @description Sets up a screen orientation listener and updates the value for
 * `screenOrientation` in every new event.
 */
  private setScreenBreakpointsListener() {
    if (this.platformService.isPlatformBrowser) {
      this.screenBreakPointsSubcription = this.responsiveService.currentBreakPoint$
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value: BreakPoints) => {
            // console.log('New Break Points : ----', value);
            let newConfig = { ...this.config1 };
            switch (value) {
              case BreakPoints.xxxl:
              case BreakPoints.xxl:
              case BreakPoints.xl:
              case BreakPoints.lg:
                newConfig.slidesPerView = 3;
                break;
              case BreakPoints.md:
              case BreakPoints.sm:
                newConfig.slidesPerView = 2;
                break;
              case BreakPoints.xs:
                newConfig.slidesPerView = 1;
                break;
              default:
                newConfig.slidesPerView = 3;
                break;
            }
            this.config1 = newConfig;
          },
          error: () => {
            console.log('Error Breakpoints observable');
          }
        });
    }
  }

  async onIntersection(e: any) {
    if (this.counterFlag) {
      await Promise.all(
        this.achievementsData.map((element: any) => {
          const countUp = new CountUp(`${element.title}`, element.title, { duration: 3 });
          countUp.start(() => {
            this.counterFlag = false
          })
        })
      )
    }
  }
}
